import React from 'react';
import { usePagination } from './hooks/usePagination';
import { useQuery } from './hooks/useQuery';
import { PaginationWrapper, PaginationContainer, PaginationItem, DotsWrapper } from './Pagination.styled';
import { Props } from './Pagination.types';
import { Icon } from 'lmc-ui-library';
import { useHistory } from 'react-router';

const Pagination: React.FC<Props> = ({ onPageChange, totalCount, siblingCount = 1, pageSize }) => {
  const query = useQuery();
  const currentPage = Number(query.get('page') || 1);

  const paginationRange: Array<number> = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const history = useHistory();

  const onNext = () => {
    onPageChange(currentPage + 1);
    query.set('page', (currentPage + 1).toString());
    const search = Object.fromEntries(query.entries());
    history.push({
      search: `?${new URLSearchParams(search).toString()}`,
    });
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
    query.set('page', (currentPage - 1).toString());
    const search = Object.fromEntries(query.entries());
    history.push({
      search: `?${new URLSearchParams(search).toString()}`,
    });
  };

  let lastPage = paginationRange[paginationRange.length - 1];

  return (
    <PaginationWrapper>
      <PaginationContainer>
        <PaginationItem key={'pagination-item-arrow-left'} onClick={onPrevious} disabled={currentPage === 1}>
          <Icon type="iconLeft" color={currentPage === 1 ? '#C0C2C6' : '#2d3540'} />
        </PaginationItem>
        {paginationRange.map((pageNumber: number) => {
          if (isNaN(pageNumber)) {
            return <DotsWrapper key={`pagination-item-${pageNumber}`}>&#8230;</DotsWrapper>;
          }

          return (
            <PaginationItem
              key={`pagination-item-${pageNumber}`}
              onClick={() => onPageChange(pageNumber)}
              selected={pageNumber === currentPage}>
              {pageNumber}
            </PaginationItem>
          );
        })}
        <PaginationItem key={'pagination-item-arrow-right'} onClick={onNext} disabled={currentPage === lastPage}>
          <Icon type="iconRight" color={currentPage === lastPage ? '#C0C2C6' : '#2d3540'} />
        </PaginationItem>
      </PaginationContainer>
    </PaginationWrapper>
  );
};

export default Pagination;
